import actionCreatorFactory from 'typescript-fsa'

import { GetFacebookPageRequest } from '@3m5/sm_publish-frontend-api/apis/FacebookPageApi'
import {
  CalendarData,
  CorePageSettings,
  FacebookPage,
  FacebookPost,
  FindGlobalPostsForPostTemplateResponse,
  InstagramPage,
  InstagramPost, LinkedInPage,
  PostTemplate,
  PostTemplatesSearchResult,
  TopicsWithMetadataResponse,
  UserAboSettings,
  WebResourceMetaData,
} from '@3m5/sm_publish-frontend-api/models'
import { GetInstagramPageRequest } from '@3m5/sm_publish-frontend-api/apis/InstagramPageApi'
import { GetCalendarDataRequest } from '@3m5/sm_publish-frontend-api/apis/CalendarApi'
import {
  FindPostTemplatesForCurrentUserLightweightRequest,
  GetFacebookPostRequest,
  GetCorePageSettingsRequest,
  UpdateAboSettingsForCurrentUserRequest,
  UpdateCorePageSettingsRequest,
  GetUrlInformationRequest,
} from '@3m5/sm_publish-frontend-api'

import { DeletePostTemplateRequest, FindGlobalPostsForPostTemplateRequest, UpdatePostTemplateRequest } from '@3m5/sm_publish-frontend-api/apis/PostTemplateApi'
import { GetInstagramPostRequest } from '@3m5/sm_publish-frontend-api/apis/InstagramPostApi'
import { DeletePostRequest, PublishPostRequest } from '@3m5/sm_publish-frontend-api/apis/PostApi'
import {
  ConfirmManualDeferredPostRequest,
  DeclineManualDeferredPostRequest,
  DeleteManualDeferredPostRequest,
  RetryManualDeferredPostRequest,
} from '@3m5/sm_publish-frontend-api/apis/DeferredPostApi'
import { GetMultipleChoiceQuizRequest } from '@professocialApi/professocial-core-frontend-api/apis/UserQuizRestServiceApi'
import { MultipleChoiceQuizDto, PageOwner } from '@professocialApi/professocial-core-frontend-api/models'
import { commonActionCreator } from '../common/common.actions'
import { GetPageMasterRequest } from '@professocialApi/professocial-core-frontend-api'
import {
  ListPageOwnersForPageRequest,
  SetUserAsPageMasterRequest,
} from '@professocialApi/professocial-core-frontend-api/apis/UserHasPageApi'
import { GetLinkedInPageRequest } from '@3m5/sm_publish-frontend-api/apis/LinkedInPageApi'

const actionCreator = actionCreatorFactory('DASHBOARD')

/*
 * Actions
 */

export const loadFacebookPageInitiated = actionCreator<GetFacebookPageRequest>('LOAD_FACEBOOK_PAGE_INITIATED')
export const loadFacebookPage = actionCreator.async<GetFacebookPageRequest, FacebookPage>('LOAD_FACEBOOK_PAGE')
export const setFacebookPage = actionCreator<FacebookPage | undefined>('SET_FACEBOOK_PAGE')

export const getIgPageInitiated = actionCreator<GetInstagramPageRequest>('GET_IG_PAGE_INITIATED')
export const getIgPage = actionCreator.async<GetInstagramPageRequest, InstagramPage>('GET_IG_PAGE')
export const setIGPage = actionCreator<InstagramPage | undefined>('SET_IG_PAGE')

export const getLinkedInPageInitiated = actionCreator<GetLinkedInPageRequest>('GET_LINKED_IN_PAGE_INITIATED')
export const getLinkedInPage = actionCreator.async<GetLinkedInPageRequest, LinkedInPage>('GET_LINKED_IN')

export const getCalendarDataInitiated = actionCreator<GetCalendarDataRequest>('GET_CALENDAR_DATA_INITIATED')
export const getCalendarData = actionCreator.async<GetCalendarDataRequest, CalendarData>('GET_CALENDAR_DATA')

export const getTopicsAndMetadataForCurrentUserInitiated = actionCreator('GET_ABO_TOPICS_INITIATED')
export const getTopicsAndMetadataForCurrentUser = actionCreator.async<undefined, TopicsWithMetadataResponse>('GET_ABO_TOPICS')

export const getAboSettingsForCurrentUserInitiated = actionCreator('GET_ABO_SETTINGS_INITIATED')
export const getAboSettingsForCurrentUser = actionCreator.async<undefined, UserAboSettings[]>('GET_ABO_SETTINGS')

export const publishPostInitiated = actionCreator<PublishPostRequest>('PUBLISH_POST_INITIATED')
export const publishPost = actionCreator.async<PublishPostRequest, undefined>('PUBLISH_POST')

export const declineManualDeferredPostInitiated = actionCreator<DeclineManualDeferredPostRequest>('DECLINE_MANUAL_DEFERRED_POST_INITIATED')
export const declineManualDeferredPost = actionCreator.async<DeclineManualDeferredPostRequest, undefined>('DECLINE_MANUAL_DEFERRED_POST')

export const confirmManualDeferredPostInitiated = actionCreator<ConfirmManualDeferredPostRequest>('CONFIRM_MANUAL_DEFERRED_POST_INITIATED')
export const confirmManualDeferredPost = actionCreator.async<ConfirmManualDeferredPostRequest, undefined>('CONFIRM_MANUAL_DEFERRED_POST')

export const deleteManualDeferredPostInitiated = actionCreator<DeleteManualDeferredPostRequest>('DELETE_MANUAL_DEFERRED_POST_INITIATED')
export const deleteManualDeferredPost = actionCreator.async<DeleteManualDeferredPostRequest, void>('DELETE_MANUAL_DEFERRED_POST')

export const retryManualDeferredPostInitiated = actionCreator<RetryManualDeferredPostRequest>('RETRY_MANUAL_DEFERRED_POST_INITIATED')
export const retryManualDeferredPost = actionCreator.async<RetryManualDeferredPostRequest, undefined>('RETRY_MANUAL_DEFERRED_POST')

export const deletePostInitiated = actionCreator<DeletePostRequest>('DELETE_POST_INITIATED')
export const deletePost = actionCreator.async<DeletePostRequest, void>('DELETE_POST')

export const setNetworkContentPage = commonActionCreator<number>('SET_NETWORK_CONTENT_PAGE')

/*
 *  Post Templates
 */

export const findPostTemplatesForCurrentUserInitiated = actionCreator<FindPostTemplatesForCurrentUserLightweightRequest>('FIND_POST_TEMPLATES_FOR_CURRENT_USER_INITIATED')
export const findPostTemplatesForCurrentUser = actionCreator.async<FindPostTemplatesForCurrentUserLightweightRequest, PostTemplatesSearchResult>('FIND_POST_TEMPLATES_FOR_CURRENT_USER')

export const updateCorePageSettingsInitiated = actionCreator<UpdateCorePageSettingsRequest>('UPDATE_CORE_PAGE_SETTINGS_INITIATED')
export const updateCorePageSettings = actionCreator.async<UpdateCorePageSettingsRequest, undefined>('UPDATE_CORE_PAGE_SETTINGS')

export const getCoreInstaPageSettingsInitiated = actionCreator<GetCorePageSettingsRequest>('GET_CORE_INSTA_PAGE_SETTINGS_INITIATED')
export const getCoreInstaPageSettings = actionCreator.async<GetCorePageSettingsRequest, CorePageSettings>('GET_CORE_INSTA_PAGE_SETTINGS')

export const getCoreFBPageSettingsInitiated = actionCreator<GetCorePageSettingsRequest>('GET_CORE_FB_PAGE_SETTINGS_INITIATED')
export const getCoreFBPageSettings = actionCreator.async<GetCorePageSettingsRequest, CorePageSettings>('GET_CORE_FB_PAGE_SETTINGS')

export const deleteCoreInstaPageSettings = actionCreator('DELETE_CORE_INSTA_PAGE_SETTINGS')
export const deleteCoreFBPageSettings = actionCreator('DELETE_CORE_FB_PAGE_SETTINGS')

export const deletePostTemplateInitiated = actionCreator<DeletePostTemplateRequest>('DELETE_POST_TEMPLATE_INITIATED')
export const deletePostTemplate = actionCreator.async<DeletePostTemplateRequest, undefined>('DELETE_POST_TEMPLATE')

export const updatePostTemplateInitiated = actionCreator<UpdatePostTemplateRequest>('UPDATE_POST_TEMPLATE_INITIATED')
export const updatePostTemplate = actionCreator.async<UpdatePostTemplateRequest, PostTemplate>('UPDATE_POST_TEMPLATE')

export const findGlobalPostsForPostTemplateInitiated = actionCreator<FindGlobalPostsForPostTemplateRequest>('FIND_GLOBAL_POSTS_FOR_POST_TEMPLATE_INITIATED')
export const findGlobalPostsForPostTemplate = actionCreator.async<FindGlobalPostsForPostTemplateRequest, FindGlobalPostsForPostTemplateResponse>('FIND_GLOBAL_POSTS_FOR_POST_TEMPLATE')

export const getFacebookPostInitiated = actionCreator<GetFacebookPostRequest>('GET_FACEBOOK_POST_INITIATED')
export const getFacebookPost = actionCreator.async<GetFacebookPostRequest, FacebookPost>('GET_FACEBOOK_POST')

export const getInstagramPostInitiated = actionCreator<GetInstagramPostRequest>('GET_INSTAGRAM_POST_INITIATED')
export const getInstagramPost = actionCreator.async<GetInstagramPostRequest, InstagramPost>('GET_INSTAGRAM_POST')

// TODO There is no GetGooglePostRequest
// export const getGooglePostInitiated = actionCreator<GetGooglePostRequest>('GET_GOOGLE_POST_INITIATED')
// export const getGooglePost = actionCreator.async<GetGooglePostRequest, GooglePost>('GET_GOOGLE_POST')

/*
 *  AboSettings
 */

export const updateAboSettingsForCurrentUserInitiated = actionCreator<UpdateAboSettingsForCurrentUserRequest>('UPDATE_ABO_SETTINGS_INITIATED')
export const updateAboSettingsForCurrentUser = actionCreator.async<UpdateAboSettingsForCurrentUserRequest, undefined>('UPDATE_ABO_SETTINGS')

/*
* Quiz
*/

export const getMultipleChoiceQuizInitiated = actionCreator<GetMultipleChoiceQuizRequest>('GET_MULTIPLE_CHOICE_QUIZ_INITIATED')
export const getMultipleChoiceQuiz = actionCreator.async<GetMultipleChoiceQuizRequest, MultipleChoiceQuizDto>('GET_MULTIPLE_CHOICE_QUIZ')

export const getSelectedMultipleChoiceQuizInitiated = actionCreator('GET_SELECTED_MULTIPLE_CHOICE_QUIZ_INITIATED')
export const getSelectedMultipleChoiceQuiz = actionCreator.async<undefined, MultipleChoiceQuizDto>('GET_SELECTED_MULTIPLE_CHOICE_QUIZ')

/*
* Connect settings
*/

export const getPageMasterInitiated = actionCreator<GetPageMasterRequest>('GET_PAGE_MASTER_INITIATED')
export const getPageMaster = actionCreator.async<GetPageMasterRequest, PageOwner>('GET_PAGE_MASTER')

export const listPageOwnersForPageInitiated = actionCreator<ListPageOwnersForPageRequest>('LIST_PAGE_OWNERS_FOR_PAGE_INITIATED')
export const listPageOwnersForPage = actionCreator.async<ListPageOwnersForPageRequest, PageOwner[]>('LIST_PAGE_OWNERS_FOR_PAGE')

export const setUserAsPageMasterInitiated = actionCreator<SetUserAsPageMasterRequest>('SET_USER_AS_PAGE_MASTER_INITIATED')
export const setUserAsPageMaster = actionCreator.async<SetUserAsPageMasterRequest, undefined>('SET_USER_AS_PAGE_MASTER')

export const getUrlInformationInitiated = actionCreator<{ data: GetUrlInformationRequest, id?: string }>('GET_URL_INFORMATION_INITIATED')
export const getUrlInformation = actionCreator.async<GetUrlInformationRequest, WebResourceMetaData>('GET_URL_INFORMATION')
